import React from "react";

export function About() {
    return (
        <div className="App">
            <br></br>
            <div className="App-header">About Us</div>
            <br></br>
            <h1>Who We Are</h1>
            <p>
                We are a group of sophomore computer science students who are
                passionate about using technology to make a positive impact in
                our community. Our latest project is a web app that helps
                connect people in Delaware with local businesses.
            </p>
            <br></br>
            <p>
                Our mission is to promote and support local businesses in our
                community by providing a platform that makes it easy for people
                to discover and connect with them. We believe that by supporting
                businesses, we can help create a more vibrant and sustainable
                community.
            </p>
            <br></br>
            <p>
                Our web app is easy to use and provides a user-friendly
                interface that allows users to search for businesses by
                category. Users can also leave reviews for businesses, which
                helps other community members make informed decisions about
                where to shop and dine. Local businesses also have the
                opportunity to add their own businesses to the website to
                further promote their company.
            </p>
            <p>
                We are constantly working to improve our platform and make it
                more useful for our users. We welcome feedback and suggestions
                from the community, so please do not hesitate to reach out to us
                with your thoughts and ideas.
            </p>
            <br></br>
            <p>
                Thank you for your support and for helping us make a positive
                impact in our community.
            </p>
            <br></br>
            <p>Sincerely,</p>
            <p>Aparna Roy, Emilie Barniak, and Samantha Glover</p>
        </div>
    );
}
